/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  // baseUrl: "http://192.168.0.110:3000",
  // baseUrl: "http://175.41.177.36:3000",
  //baseUrl: "http://localhost:3000",
  //baseUrl: "http://175.41.177.36:4000",
  //baseUrl: "https://175.41.177.36:4000",
  //baseUrl: "http://localhost:4000",
  // baseUrl: "http://admin.nammavirundhu.com:4000",
  baseUrl: "https://admin.nammavirundhu.com:4000",
};
